import Link from "next/link";
import { ChevronLeft } from "lucide-react";
import { cn } from "@/lib/utils";

interface BackLinkProps {
  href: string;
  children: React.ReactNode;
  className?: string;
}

function BackLink({ href, children, className }: BackLinkProps) {
  return (
    <Link
      href={href}
      className={cn(
        "inline-flex items-center gap-[var(--space-0-5)] text-[length:var(--font-size-sm)] text-[var(--color-text-muted)] hover:text-[var(--color-text-primary)] transition-colors",
        className,
      )}
    >
      <ChevronLeft className="size-4" />
      {children}
    </Link>
  );
}

export { BackLink };
export type { BackLinkProps };
